import * as Tooltip from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';

type TooltipProps = {
  tooltip?: string;
  side?: 'bottom' | 'left' | 'right' | 'top';
  arrowOffset?: number;
  children: ReactNode;
};

export const TooltipComponent = ({ tooltip, side, children }: TooltipProps) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div className="">{children}</div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            className="data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade tw-text-white tw-select-none tw-rounded-[4px] tw-bg-black tw-px-[15px] tw-py-[10px] tw-text-[15px] tw-leading-none tw-shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] tw-will-change-[transform,opacity] tw-max-w-sm"
            sideOffset={5}
          >
            {tooltip}
            <Tooltip.Arrow className="tw-fill-black" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export const LeadBtnTooltipComponent = ({
  tooltip,
  side,
  arrowOffset,
  children
}: TooltipProps) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div className="">{children}</div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            className="data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade tw-text-white tw-select-none tw-rounded-[4px] tw-bg-black tw-px-[15px] tw-py-[10px] tw-text-[15px] tw-leading-none tw-shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] tw-will-change-[transform,opacity] tw-max-w-sm"
            sideOffset={5}
          >
            {tooltip}
            <Tooltip.Arrow className="tw-fill-black tw-ml-[100px]" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
